import { render, staticRenderFns } from "./Cierre-caja-modal.vue?vue&type=template&id=2261a8b6&scoped=true"
import script from "./Cierre-caja-modal.vue?vue&type=script&lang=js"
export * from "./Cierre-caja-modal.vue?vue&type=script&lang=js"
import style0 from "./Cierre-caja-modal.vue?vue&type=style&index=0&id=2261a8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2261a8b6",
  null
  
)

export default component.exports